import { CSSProperties, forwardRef, MouseEventHandler, useRef } from "react";
import { Button } from "reactstrap";
import { Tooltip, Whisper, WhisperInstance } from "rsuite";
import AppSpinner from "./AppSpinner";

interface IconButtonProps {
  icon: string;
  tooltipText?: string;
  size?: string;
  color?: string;
  outline?: boolean;
  loading?: boolean;
  disabled?: boolean;
  className?: string | null;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
  wide?: boolean;
}

const IconButton = ({
  onClick,
  icon = "",
  tooltipText,
  size = "sm",
  color = "secondary",
  outline = true,
  loading = false,
  disabled = false,
  className = null,
  style,
  iconStyle,
  wide = false,
}: IconButtonProps) => {
  const tooltipRef = useRef<WhisperInstance>(null);

  const TheButton = forwardRef((props, ref: any) => (
    <Button
      style={style}
      size={size}
      outline={outline}
      color={color}
      onClick={(e) => {
        onClick && onClick(e);
        tooltipRef.current?.close();
      }}
      disabled={disabled || loading}
      ref={ref}
      className={`${className} btn-icon-only ${wide ? "btn-icon-wide" : ""}`}
      {...props}
    >
      {loading ? (
        <AppSpinner size="sm" />
      ) : (
        <i
          className={`mdi mdi-${icon}`}
          style={{
            fontSize: size === "xl" ? 63 : undefined,
            ...(iconStyle || {}),
          }}
        />
      )}
    </Button>
  ));

  return !disabled && tooltipText ? (
    <Whisper
      ref={tooltipRef}
      placement="left"
      trigger="hover"
      speaker={<Tooltip style={{ minWidth: 150 }}>{tooltipText}</Tooltip>}
    >
      <TheButton />
    </Whisper>
  ) : (
    <TheButton />
  );
};

export default IconButton;
